import React, { useEffect, useState } from 'react'
import { Panel } from 'rsuite'
import 'rsuite/dist/rsuite.min.css'
import { PanelHeader } from '../panels'
import { OtherPersonIcon } from '../icons'
import { useParams } from 'react-router-dom'
import { useEnvironment } from '../../hooks/useEnvironment'
import { useRequestsEvents } from '../../hooks/useRequestsEvents'
import { EmptyResult, ErrorResult, LoaderBackDrop } from '../feedbacks'
import _ from 'lodash'
import { PromotionPersonTable } from './tables/PromotionPersonTable'

export const PromotionPersonContactPanel = (props) => {
  // get current promotion id
  const { promotionId } = useParams()
  // for get promotions
  const { getPromotionContact } = useRequestsEvents()
  // get for check permissions
  const { hasPromotionPermissions } = useEnvironment()
  // component config
  const [componentCfg, setComponentCfg] = useState({
    data: {},
    show: true,
    isLoaded: false,
    isError: false,
    isForbidden: false
  }) // permissions
  const hasReadClientPromotionPermission = hasPromotionPermissions(promotionId, 'read:promotion:client') && !componentCfg.isForbidden
  const hasUpdateClientPromotionPermission = hasPromotionPermissions(promotionId, 'update:promotion:client') && !componentCfg.isForbidden
  const hasDeleteClientPromotionPermission = hasPromotionPermissions(promotionId, 'delete:promotion:client') && !componentCfg.isForbidden

  // for load all promotions data when component is mounted
  useEffect(() => {
    // clean up controller --> prevent crash with async function
    let isMounted = true
    // not reload if component is loaded...
    if (componentCfg.isLoaded) { return }
    // if not has permissions
    if (!hasReadClientPromotionPermission) {
      setComponentCfg({ ...componentCfg, isError: false, isLoaded: true, show: false, data: {} })
    } else {
      // get promotion holder data
      getPromotionContact(promotionId, (result) => {
        // prevent async crash
        if (!isMounted) return null
        // get holder data
        const data = result.data
        // set holder data
        setComponentCfg({ ...componentCfg, isError: false, isLoaded: true, show: !!(data), data, isForbidden: false })
      }, (err) => {
        // prevent async crash
        if (!isMounted) return null
        if (err === 403) {
          setComponentCfg({ ...componentCfg, isError: false, isLoaded: true, show: true, data: {}, isForbidden: true })
        } else {
          setComponentCfg({ ...componentCfg, isError: true, isLoaded: true, show: true, data: {}, isForbidden: false })
        }
      })
    }// prevent crash with async function
    return () => { isMounted = false }
  }, [componentCfg.isLoaded])

  return (<>
    {(() => { /* check permissions */
      if (!hasReadClientPromotionPermission || _.isEmpty(componentCfg.data)) {
        return <></>
      } else { /* render a panel */
        return (
          <Panel bodyFill header={
            <PanelHeader icon={<OtherPersonIcon />} title={'dashboard.promotion.person_other'} hasEdit={hasUpdateClientPromotionPermission} hasDelete={hasDeleteClientPromotionPermission} />
          }>
            <LoaderBackDrop active={!componentCfg.isLoaded} loader background bordered>
              <Panel className={'filled-table-panel'} style={{ borderRadius: '4px' }} bordered bodyFill>
                  { /* load component */ }
                  {(() => {
                    if (componentCfg.isError) {
                      return <ErrorResult compact={true}/>
                    } else if (_.isEmpty(componentCfg.data)) {
                      return <EmptyResult compact={true} />
                    } else { /* return components to render */
                      return <PromotionPersonTable data={componentCfg.data}/>
                    }
                  })()}
              </Panel>
            </LoaderBackDrop>
          </Panel>
        )
      }
    })()}
  </>)
}
